/**
 * Русские лейблы для статусов заказа.
 *
 * ВНИМАНИЕ: client (Mini App) и admin-панель исторически использовали РАЗНЫЕ
 * формулировки — они адресованы разным аудиториям:
 *   - клиент видит "Ждём QR-код" (что юзер должен сделать),
 *   - админ видит "Корзина проверена" (внутренний этап обработки).
 *
 * Чтобы рефакторинг не менял UI-поведение, экспортируем оба словаря.
 *
 * Источники:
 *   - CLIENT — apps/client/src/screens/OrdersScreen.tsx (исходный STATUS_LABELS)
 *   - ADMIN  — apps/admin/src/lib/orders.ts (исходный STATUS_LABEL)
 */
export const STATUS_LABELS_RU_CLIENT = {
    draft: "Черновик",
    approved: "Ждём QR-код",
    has_qr: "QR отправлен",
    picked_up: "Получено на ПВЗ",
    in_transit: "В пути · Россия → Грузия",
    at_warehouse: "На складе в Тбилиси",
    ready: "Готово к выдаче",
    delivered: "Выдано",
    pending_recipient_data: "Нужно заполнить получателя",
};
export const STATUS_LABELS_RU_ADMIN = {
    draft: "Черновик",
    approved: "Корзина проверена",
    has_qr: "QR получен",
    picked_up: "Забран на ПВЗ",
    in_transit: "В пути",
    at_warehouse: "На складе TBS",
    ready: "Готово к выдаче",
    delivered: "Выдано",
    pending_recipient_data: "Pre-order: получатель не заполнен",
};
/**
 * Цвет/тон бейджа статуса для admin-таблиц. Только admin использует, поэтому
 * один словарь.
 */
export const STATUS_BADGES = {
    draft: "gray",
    approved: "gray",
    has_qr: "yellow",
    picked_up: "purple",
    in_transit: "blue",
    at_warehouse: "purple",
    ready: "teal",
    delivered: "green",
    pending_recipient_data: "orange",
};
/**
 * Краткие лейблы статусов для узких колонок в admin.
 */
export const STATUS_SHORT = {
    draft: "Черн.",
    approved: "Подтв.",
    has_qr: "QR",
    picked_up: "ПВЗ",
    in_transit: "Путь",
    at_warehouse: "Склад",
    ready: "Выдача",
    delivered: "Выдано",
    pending_recipient_data: "Pre-ord",
};
/**
 * Лейблы направлений (направление перевозки). Тоже две версии — admin
 * сокращает "Самовывоз", клиент пишет "Забор". Сохраняем как было.
 * Ключ направления Ozon/WB удалён 2026-06-12 (волна 2 PR6, архив —
 * ветка archive/ozonwb-flow): его строки в UI не рендерятся, а потребители
 * словарей падают на raw-значение через `?? direction`.
 */
export const DIRECTION_LABELS_RU_CLIENT = {
    flex: "Flex-отправка",
    from_rf: "Из РФ",
    to_rf: "В РФ",
    receipt: "Чек",
    pickup: "Забор",
    packing: "Упаковка",
};
export const DIRECTION_LABELS_RU_ADMIN = {
    flex: "Flex",
    from_rf: "Из РФ",
    to_rf: "В РФ",
    receipt: "Чек",
    pickup: "Самовывоз",
    packing: "Упаковка",
};
/**
 * Канонический порядок статусов для пайплайна заказа (без `draft`). Используется
 * в admin для сортировки/прогресс-индикаторов.
 */
export const STATUS_ORDER = [
    "approved",
    "has_qr",
    "picked_up",
    "in_transit",
    "at_warehouse",
    "ready",
    "delivered",
];
//# sourceMappingURL=index.js.map